import { Role } from '@/utils/models/UserData';

// Mapeamento estático de role → páginas permitidas
export const ROLE_PERMISSIONS: Record<Role, string[]> = {
  OWNER: [
    '/dashboard',
    '/dashboard/produtos',
    '/dashboard/clientes',
    '/dashboard/inscricoes',
    '/dashboard/afiliados',
    '/dashboard/agenda',
    '/dashboard/notificacoes',
    '/dashboard/minha-empresa',
    '/dashboard/meu-perfil',
  ],
  OPERATOR: [
    '/dashboard/produtos',
    '/dashboard/clientes',
    '/dashboard/inscricoes',
    '/dashboard/afiliados',
    '/dashboard/agenda',
    '/dashboard/notificacoes',
    '/dashboard/minha-empresa',
    '/dashboard/meu-perfil',
  ],
};

// Páginas que aparecem na sidebar (usadas para filtrar)
export const SIDEBAR_PATHS = {
  dashboard: '/dashboard',
  produtos: '/dashboard/produtos',
  clientes: '/dashboard/clientes',
  inscricoes: '/dashboard/inscricoes',
  afiliados: '/dashboard/afiliados',
  agenda: '/dashboard/agenda',
  notificacoes: '/dashboard/notificacoes',
  minhaEmpresa: '/dashboard/minha-empresa',
} as const;

export function canAccessPath(role: Role | undefined, path: string): boolean {
  if (!role) return false;
  const permissions = ROLE_PERMISSIONS[role];
  return permissions.includes(path);
}

export function canCreateUsers(role: Role | undefined): boolean {
  return role === 'OWNER';
}

